import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';

export class ImportExportConfig implements IConfigObjectBase {
	id: string = Guid();
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	objectState?: ObjectState;

	constructor(init?: Partial<ImportExportConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
